import prepareBanner from './prepareBanner';

/**
 * Render-time banner preparation. Call unconditionally from producers; gate
 * eligibility with `enabled` (or inside the owning AdStore action). The store
 * owns cache, live requests, and automatic retries.
 *
 * @param {Object} props
 * @param {Object} props.adStore
 * @param {Object} props.searchParameters
 * @param {String} [props.path]
 * @param {Boolean} [props.enabled]
 */
const usePrepareBanner = (props) => {
  prepareBanner(props);
};

export default usePrepareBanner;
